<rt-dropdown [width]="DropdownWidth.FullWidth">
  <div #dropdownContainer rtScrollable [style.maxHeight]="maxHeight + 'px'" class="dropdown">
    @for (option of options; track trackByOption($index, option)) {
      <rt-dropdown-item
        #itemsQuery
        [class.active]="option.value === currentOption?.value"
        (click)="onSelect(option)"
        class="dropdown-item"
      >
        {{ option.label }}
      </rt-dropdown-item>
    }
  </div>
</rt-dropdown>
